// Swiper documentation: https://swiperjs.com/swiper-api
// possible imports: A11y, Autoplay, Controller, EffectCards, EffectCoverflow, EffectCreative, EffectCube, EffectFade, EffectFlip, FreeMode, Grid, HashNavigation, History, Keyboard, Manipulation, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Swiper from 'swiper';
import {
    Navigation,
    Pagination,
    Autoplay,
    Scrollbar,
    FreeMode,
    EffectFade
} from 'swiper/modules';

jQuery(document).ready(function($){

    const mixedMediaSwipers = $('.mixed-media__swiper');
    mixedMediaSwipers.each((i, el) => {
        $(el).addClass(`mixed-media__swiper-${i}`);
        let desktopSlidesPerPage = $(el).attr('data-desktop-slides-per-page');
        let desktopNavigationType = $(el).attr('data-desktop-navigation-type');
        let desktopCustomSpeed = $(el).attr('data-desktop-custom-speed');
        let desktopEnableAutoplay = desktopNavigationType === 'none' ? true : false;

        let tabletSlidesPerPage = $(el).attr('data-tablet-slides-per-page');
        let tabletNavigationType = $(el).attr('data-tablet-navigation-type');
        let tabletCustomSpeed = $(el).attr('data-tablet-custom-speed');
        let tabletEnableAutoplay = tabletNavigationType === 'none' ? true : false;

        let mobileSlidesPerPage = $(el).attr('data-mobile-slides-per-page');
        let mobileNavigationType = $(el).attr('data-mobile-navigation-type');
        let mobileCustomSpeed = $(el).attr('data-mobile-custom-speed');
        let mobileEnableAutoplay = mobileNavigationType === 'none' ? true : false;

        let numOfSlides = $(el).attr('data-media-count');
        let desktopSpeed = desktopCustomSpeed ? desktopCustomSpeed : numOfSlides * 1200;
        let tabletSpeed = tabletCustomSpeed ? tabletCustomSpeed : numOfSlides * 800;
        let mobileSpeed = mobileCustomSpeed ? mobileCustomSpeed : numOfSlides * 500;

        let pagination = {
            el: $(`.mixed-media__swiper-${i}`).siblings('.mixed-media__controls').find('.mixed-media__controls__pagination').get(0),
            type: "fraction",
        };
        let navigation = {
            nextEl: $(`.mixed-media__swiper-${i}`).siblings('.mixed-media__controls').find('.mixed-media__controls__next').get(0),
            prevEl: $(`.mixed-media__swiper-${i}`).siblings('.mixed-media__controls').find('.mixed-media__controls__prev').get(0),
        };

        let mixedMediaSwiper = new Swiper('.mixed-media__swiper-' + i, {
            modules: [Navigation, Pagination, FreeMode, Autoplay],
            direction: 'horizontal',
            spaceBetween: 20,
            loop: mobileEnableAutoplay,
            slidesPerView: mobileSlidesPerPage,
            speed: mobileSpeed,
            pagination: mobileNavigationType != 'none' ? pagination : false,
            navigation: mobileNavigationType != 'none' ? navigation : false,
            freeMode: mobileEnableAutoplay,
            autoplay: {
                enabled: mobileEnableAutoplay,
                delay: 0,
            },
            grabCursor: true,
            freeModeMomentum: false,
    
            breakpoints: {
                // when window width is >= breakpoint
                768: {
                    slidesPerView: tabletSlidesPerPage,
                    speed: tabletSpeed,
                    loop: tabletEnableAutoplay,
                    pagination: tabletNavigationType !== 'none' ? pagination : false,
                    navigation: tabletNavigationType !== 'none' ? navigation : false,
                    freeMode: tabletEnableAutoplay,
                    autoplay: {
                        enabled: tabletEnableAutoplay,
                    },
                },
                1025: {
                    slidesPerView: desktopSlidesPerPage,
                    speed: desktopSpeed,
                    loop: desktopEnableAutoplay,
                    pagination: desktopNavigationType !== 'none' ? pagination : false,
                    navigation: desktopNavigationType !== 'none' ? navigation : false,
                    freeMode: desktopEnableAutoplay,
                    autoplay: {
                        enabled: desktopEnableAutoplay,
                    },
                }
            },

        });
    })


    const videoSubmoduleSwipers = $('.videos-submodule__swiper');
    videoSubmoduleSwipers.each((i, el) => {
        $(el).addClass(`videos-submodule__swiper-${i}`);

        let mobileSlidesPerView = $(el).attr('data-mobile-slides-per-view');

        let pagination = {
            el: $(`.videos-submodule__swiper-${i} .videos-submodule__controls__pagination`).get(0),
            type: "fraction",
        };
        let navigation = {
            nextEl: $(`.videos-submodule__swiper-${i} .videos-submodule__controls__next`).get(0),
            prevEl: $(`.videos-submodule__swiper-${i} .videos-submodule__controls__prev`).get(0),
        };

        let videoSubmoduleSwiper = new Swiper('.videos-submodule__swiper-' + i, {
            modules: [Navigation, Pagination],
            direction: 'horizontal',
            spaceBetween: 20,
            loop: false,
            slidesPerView: mobileSlidesPerView,
            pagination: pagination,
            navigation: navigation,
    
            breakpoints: {
                // when window width is >= breakpoint
                768: {
                    enabled: false
                },
            },

        });
    })


    const allGallerySwipers = $('.gallery__swiper');
    allGallerySwipers.each((i, el) => {
        $(el).addClass(`gallery__swiper-${i}`);
        let slidesPerPageDesktop = $(el).attr('data-slides-per-page-desktop');
        let slidesPerPageTablet = $(el).attr('data-slides-per-page-tablet');
        let slidesPerPageMobile = $(el).attr('data-slides-per-page-mobile');
        let showGradients = $(el).attr('data-show-gradients');
        let navigationType = $(el).attr('data-navigation-type');
        let enableAutoplay = navigationType === 'none' ? true : false;

        let pagination = '';
        let navigation = '';
        if (navigationType === 'fraction') {
            pagination = {
                el: ".gallery-pagination",
                type: "fraction",
            };
            navigation = {
                nextEl: ".gallery-next",
                prevEl: ".gallery-prev",
            };
        }

        let gallerySwiper = new Swiper('.gallery__swiper-' + i, {
            modules: [Navigation, Pagination, FreeMode, Autoplay],
            direction: 'horizontal',
            loop: enableAutoplay,
            spaceBetween: 20,
            slidesPerView: slidesPerPageMobile,
            slidesPerGroup: Math.floor(slidesPerPageMobile),
    
            pagination: pagination,
            navigation: navigation,
    
            breakpoints: {
                // when window width is >= breakpoint
                768: {
                    slidesPerView: slidesPerPageTablet,
                    slidesPerGroup: Math.floor(slidesPerPageTablet),
                },
                1025: {
                    slidesPerView: slidesPerPageDesktop,
                    slidesPerGroup: Math.floor(slidesPerPageDesktop)
                }
            },

            freeMode: enableAutoplay,
            grabCursor: enableAutoplay,
            autoplay: {
                enabled: enableAutoplay,
                delay: 0,
                disableOnInteraction: true
            },
            speed: enableAutoplay ? '7000' : '300',
            freeModeMomentum: false
        });
        
        if (showGradients && !enableAutoplay) {
            gallerySwiper.on('slideChange', function () {
                if (this.isBeginning) {
                    $(el).find('.gallery-gradient__left').hide();
                }
                else if (this.isEnd) {
                    $(el).find('.gallery-gradient__right').hide();
                }
                else {
                    $(el).find('.gallery-gradient__left').show();
                    $(el).find('.gallery-gradient__right').show();
                }
            });
        }
    })

    const allOurWorkSections = $('.our-work-section');
    allOurWorkSections.each((i, el) => {
        $(el).addClass(`our-work-section-${i}`);
        $(el).find('.our-work-section__swiper').addClass(`our-work-section__swiper-${i}`);

        let ourWorkSwiper = new Swiper('.our-work-section__swiper-' + i, {
            modules: [Navigation, Pagination, EffectFade],
            // Optional parameters
            loop: false,
            spaceBetween: 112,
            slidesPerView: 1,
            slidesPerGroup: 1,
            autoHeight: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
    
            pagination: {
                el: '.our-work-pagination',
                type: "fraction"
            },
    
            navigation: {
                nextEl: '.our-work-next',
                prevEl: '.our-work-prev',
            },

            on: {
                afterInit: function () {
                    let backgroundColor = this.slides[0].getAttribute("data-slide-bg-color");
                    $(el).find('.our-work-section-inner-wrapper').css('backgroundColor', backgroundColor);

                    moveControls();
                },
              }
        });

        ourWorkSwiper.on("activeIndexChange", function () {
            let activeSlide = this.slides[this.activeIndex];
            let backgroundColor = activeSlide.getAttribute("data-slide-bg-color");
            $(el).find('.our-work-section-inner-wrapper').css('backgroundColor', backgroundColor);
            const vimeoIframes = $(el).find('.our-work-section__slide-content__oembed iframe[src*="player.vimeo.com"]');
            if (vimeoIframes.length) {
                vimeoIframes.each((i, vimeoIframe) => {
                    const vimeoPlayer = new Vimeo.Player(vimeoIframe);
                    vimeoPlayer.pause();
                });
            }
        });

        ourWorkSwiper.on("resize", function () {
            moveControls();
        });

        function moveControls() {
            let mobileControlsPosition = $(el).find('.our-work-section__mobile-controls-position');
            let desktopControlsPosition = $(el).find('.our-work-section__desktop-controls-position');
            let swiperControls = $(el).find('.our-work-section__controls-wrapper');
            let screenSize = document.documentElement.clientWidth

            if (screenSize <= 1024) {
                swiperControls.appendTo(mobileControlsPosition);
            } else {
                swiperControls.appendTo(desktopControlsPosition);
            }
        }
    })
    

    let expertTestimonialsTextSwiper = new Swiper('.expert-testimonials-section__text-swiper', {
        modules: [Navigation, Pagination, EffectFade],
        // Optional parameters
        loop: false,
        spaceBetween: 20,
        slidesPerView: 1,
        slidesPerGroup: 1,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoHeight: true,

        pagination: {
            el: '.expert-testimonials-pagination',
            type: "fraction"
        },

        navigation: {
            nextEl: '.expert-testimonials-next',
            prevEl: '.expert-testimonials-prev',
        },
        on: {
            afterInit: function () {
                moveExpertTestimonialControls();
            },
          }
    });

    expertTestimonialsTextSwiper.on("resize", function () {
        moveExpertTestimonialControls();
    });

    function moveExpertTestimonialControls() {
        let mobileControlsPosition = $('.expert-testimonials-section__mobile-controls-position');
        let desktopControlsPosition = $('.expert-testimonials-section__desktop-controls-position');
        let swiperControls = $('.expert-testimonials-section__controls-wrapper');
        let screenSize = document.documentElement.clientWidth;

        if (screenSize <= 1024) {
            swiperControls.appendTo(mobileControlsPosition);
        } else {
            swiperControls.appendTo(desktopControlsPosition);
        }
    }

    let expertTestimonialsImageSwiper = new Swiper('.expert-testimonials-section__image-swiper', {
        modules: [Navigation, Pagination, EffectFade],
        // Optional parameters
        loop: false,
        spaceBetween: 20,
        slidesPerView: 1,
        slidesPerGroup: 1,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        // autoHeight: true,

        pagination: {
            el: '.expert-testimonials-pagination',
            type: "fraction"
        },

        navigation: {
            nextEl: '.expert-testimonials-next',
            prevEl: '.expert-testimonials-prev',
        },
    });


    let caseStudyTestimonialsTextSwiper = new Swiper('.testimonials-type-case-study__text-swiper', {
        modules: [Navigation, Pagination, EffectFade],
        // Optional parameters
        loop: false,
        spaceBetween: 20,
        slidesPerView: 1,
        slidesPerGroup: 1,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoHeight: true,

        pagination: {
            el: '.testimonials-type-case-study__controls__pagination',
            type: "fraction"
        },

        navigation: {
            nextEl: '.testimonials-type-case-study__controls__next',
            prevEl: '.testimonials-type-case-study__controls__prev',
        },
    });


    let caseStudyTestimonialsImageSwiper = new Swiper('.testimonials-type-case-study__image-swiper', {
        modules: [Navigation, Pagination, EffectFade],
        // Optional parameters
        loop: false,
        spaceBetween: 20,
        slidesPerView: 1,
        slidesPerGroup: 1,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        // autoHeight: true,

        pagination: {
            el: '.testimonials-type-case-study__controls__pagination',
            type: "fraction"
        },

        navigation: {
            nextEl: '.testimonials-type-case-study__controls__next',
            prevEl: '.testimonials-type-case-study__controls__prev',
        },
    });


    const allTestimonialKudosSwipers = $('.testimonials-type-kudos .testimonials__swiper');
    allTestimonialKudosSwipers.each((i, el) => {
        $(el).addClass(`testimonials__swiper-${i}`);
        let section = $(el).parent().parent('section');

        let testimonialKudosSwiper = new Swiper('.testimonials__swiper-' + i, {
            modules: [Navigation, Pagination, EffectFade],
            // Optional parameters
            loop: false,
            spaceBetween: 20,
            slidesPerView: 1,
            slidesPerGroup: 1,
            autoHeight: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
    
            pagination: {
                el: '.testimonials__controls__pagination',
                type: "fraction"
            },
    
            navigation: {
                nextEl: '.testimonials__controls__next',
                prevEl: '.testimonials__controls__prev',
            },

            on: {
                afterInit: function () {
                    let backgroundColor = this.slides[0].getAttribute("data-slide-bg-color");
                    section.css('backgroundColor', backgroundColor);
                },
              }
        });

        testimonialKudosSwiper.on("activeIndexChange", function () {
            let activeSlide = this.slides[this.activeIndex];
            let backgroundColor = activeSlide.getAttribute("data-slide-bg-color");
            let textColor = activeSlide.getAttribute("data-slide-text-color");
            if (backgroundIsDark(backgroundColor)) {
                section.addClass('background-color-dark');
                section.removeClass('background-color-light');
            } else {
                section.removeClass('background-color-dark');
                section.addClass('background-color-light');
            }
            section.css({'backgroundColor': backgroundColor});
        });
    })

    const allTestimonialKudosPartialSwipers = $('.kudos-testimonials-slide-testimonial-only__swiper');
    allTestimonialKudosPartialSwipers.each((i, el) => {
        $(el).addClass(`kudos-testimonials-slide-testimonial-only__swiper-${i}`);
        let section = $(el).parent().parent().parent('section');

        let testimonialKudosPartialSwiper = new Swiper('.kudos-testimonials-slide-testimonial-only__swiper-' + i, {
            modules: [Navigation, Pagination, EffectFade],
            // Optional parameters
            loop: false,
            spaceBetween: 20,
            slidesPerView: 1,
            slidesPerGroup: 1,
            autoHeight: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
    
            pagination: {
                el: '.kudos-testimonials-slide-testimonial-only__controls__pagination',
                type: "fraction"
            },
    
            navigation: {
                nextEl: '.kudos-testimonials-slide-testimonial-only__controls__next',
                prevEl: '.kudos-testimonials-slide-testimonial-only__controls__prev',
            },

            on: {
                afterInit: function () {
                    let backgroundColor = this.slides[0].getAttribute("data-slide-bg-color");
                    section.css('backgroundColor', backgroundColor);
                },
              }
        });

        testimonialKudosPartialSwiper.on("activeIndexChange", function () {
            let activeSlide = this.slides[this.activeIndex];
            let backgroundColor = activeSlide.getAttribute("data-slide-bg-color");
            if (backgroundIsDark(backgroundColor)) {
                section.addClass('background-color-dark');
                section.removeClass('background-color-light');
            } else {
                section.removeClass('background-color-dark');
                section.addClass('background-color-light');
            }
            section.css({'backgroundColor': backgroundColor});
        });
    })


    const allCustomTestimonialSwipers = $('.custom-testimonials__swiper');
    allCustomTestimonialSwipers.each((i, el) => {
        $(el).addClass(`custom-testimonials__swiper-${i}`);
        let section = $(el).parent().parent('section');

        let testimonialCardSwiper = new Swiper('.custom-testimonials__swiper-' + i, {
            modules: [Navigation, Pagination, EffectFade],
            // Optional parameters
            loop: false,
            spaceBetween: 20,
            slidesPerView: 1,
            slidesPerGroup: 1,
            autoHeight: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
    
            pagination: {
                el: '.custom-testimonials__controls__pagination',
                type: "fraction"
            },
    
            navigation: {
                nextEl: '.custom-testimonials__controls__next',
                prevEl: '.custom-testimonials__controls__prev',
            },

            on: {
                afterInit: function () {

                },
              }
        });
    })


    const allTeamMemberSwipers = $('.team-members__swiper');
    allTeamMemberSwipers.each((i, el) => {
        $(el).addClass(`team-members__swiper-${i}`);
        let numOfSlides = parseInt($(el).attr('data-number-of-slides'));
        let desktopSlidesPerView = parseFloat($(el).attr('data-desktop-slides-per-view'));
        let desktopSpaceBetweenSlides = $(el).attr('data-desktop-space-between-slides');
        let tabletSlidesPerView = parseFloat($(el).attr('data-tablet-slides-per-view'));
        let tabletSpaceBetweenSlides = $(el).attr('data-tablet-space-between-slides');
        let mobileSlidesPerView = parseFloat($(el).attr('data-mobile-slides-per-view'));
        let mobileSpaceBetweenSlides = $(el).attr('data-mobile-space-between-slides');

        let teamMembersSwiper = new Swiper(`.team-members__swiper-${i}`, {
            modules: [Navigation],
            direction: 'horizontal',
            spaceBetween: mobileSpaceBetweenSlides,
            slidesPerView: mobileSlidesPerView,
            grabCursor: true,
            navigation: {
                nextEl: '.team-members__swiper__controls__next',
                prevEl: '.team-members__swiper__controls__prev',
            },

            breakpoints: {
                // when window width is >= breakpoint
                768: {
                    slidesPerView: tabletSlidesPerView,
                    spaceBetween: tabletSpaceBetweenSlides
                },
                1025: {
                    slidesPerView: desktopSlidesPerView,
                    spaceBetween: desktopSpaceBetweenSlides
                }
            },
        });

        

        
    })


    const allCustomCardsSwipers = $('.custom-cards__swiper');
    allCustomCardsSwipers.each((i, el) => {
        $(el).addClass(`custom-cards__swiper-${i}`);
        let desktopEnabled = $(el).attr('data-enable-swiper-desktop');
        let desktopCardsPerView = $(el).attr('data-desktop-slides-per-page');
        let tabletEnabled = $(el).attr('data-enable-swiper-tablet');
        let tabletCardsPerView = $(el).attr('data-tablet-slides-per-page');
        let mobileEnabled = $(el).attr('data-enable-swiper-mobile');
        let mobileCardsPerView = $(el).attr('data-mobile-slides-per-page');

        let customCardsSwiper = new Swiper(`.custom-cards__swiper-${i}`, {
            modules: [FreeMode, Autoplay, Navigation, Pagination],
            enabled: mobileEnabled ? true : false,
            direction: 'horizontal',
            loop: true,
            spaceBetween: 20,
            slidesPerView: mobileCardsPerView,
            freeMode: true,
            grabCursor: true,
            freeModeMomentum: false,
            autoHeight: false,
    
            navigation: {
                nextEl: '.custom-cards__swiper__controls__next',
                prevEl: '.custom-cards__swiper__controls__prev',
            },

            breakpoints: {
                // when window width is >= breakpoint
                768: {
                    enabled: tabletEnabled ? true : false,
                    slidesPerView: tabletCardsPerView,
                },
                1025: {
                    enabled: desktopEnabled ? true : false,
                    slidesPerView: desktopCardsPerView,
                }
            },
        });
    })


    const allResultsCardsSwipers = $('.results-cards__swiper');
    allResultsCardsSwipers.each((i, el) => {
        $(el).addClass(`results-cards__swiper-${i}`);

        let desktopCardsPerView = $(el).attr('data-desktop-slides-per-view');
        let tabletCardsPerView = $(el).attr('data-tablet-slides-per-view');
        let mobileCardsPerView = $(el).attr('data-mobile-slides-per-view');

        let numOfSlides = $(el).attr('data-number-of-slides');
        let desktopSpeed = numOfSlides * 1200;
        let tabletSpeed = numOfSlides * 800;
        let mobileSpeed = numOfSlides * 800;

        let resultsCardsSwiper = new Swiper(`.results-cards__swiper-${i}`, {
            modules: [FreeMode, Autoplay, Navigation, Pagination],
            direction: 'horizontal',
            loop: true,
            spaceBetween: 20,
            slidesPerView: mobileCardsPerView,
            speed: mobileSpeed,
            freeMode: true,
            grabCursor: true,
            autoplay: {
                enabled: true,
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            },
            freeModeMomentum: false,
            autoHeight: false,
            pagination: {
                el: '.results-cards__controls__pagination',
                type: "fraction"
            },
    
            navigation: {
                nextEl: '.results-cards__controls__next',
                prevEl: '.results-cards__controls__prev',
            },

            breakpoints: {
                // when window width is >= breakpoint
                768: {
                    slidesPerView: tabletCardsPerView,
                    speed: tabletSpeed,
                },
                1025: {
                    slidesPerView: desktopCardsPerView,
                    speed: desktopSpeed,
                }
            },
        });
    })


    const allRecentPostsSwipers = $('.recent-posts__swiper');
    allRecentPostsSwipers.each((i, el) => {
        $(el).addClass(`recent-posts__swiper-${i}`);
        let slidesPerPageDesktop = $(el).attr('data-slides-per-page-desktop');
        let slidesPerPageTablet = $(el).attr('data-slides-per-page-tablet');
        let slidesPerPageMobile = $(el).attr('data-slides-per-page-mobile');

        let recentPostsSwiper = new Swiper('.recent-posts__swiper-' + i, {
            modules: [Navigation, Pagination],
            direction: 'horizontal',
            loop: false,
            spaceBetween: 30,
            slidesPerView: slidesPerPageMobile,
    
            pagination: {
                el: ".recent-posts-pagination",
                type: "fraction",
              },
            navigation: {
            nextEl: ".recent-posts-next",
            prevEl: ".recent-posts-prev",
            },
    
            breakpoints: {
                // when window width is >= breakpoint
                768: {
                    slidesPerView: slidesPerPageTablet,
                },
                1025: {
                    slidesPerView: slidesPerPageDesktop,
                },
                // 1200: {
                //     slidesPerView: 2.9,
                // },
            },
        });
    })

});
